export default {"src":"/_next/static/media/people.368a5bdb.svg","height":12,"width":16};